<div class="dashboard-email-page">
  <div class="dashboard-email-page__title">E-Mails</div>
  <form
    class="dashboard-email-page__form"
    fxLayout="column"
    fxLayoutGap="20px"
    [formGroup]="emailPageForm"
    dashboardConnectForm
  >
    <div *ngIf="selectedStudy?.type !== StudyType.CC">
      <div fxLayout="column" class="dashboard-email-page__column">
        <div class="dashboard-email-page__column-title">Study starts</div>
        <mat-tab-group
          mat-align-tabs="end"
          #languageTabs
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
          (animationDone)="selectFirstTab()"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-container *ngTemplateOutlet="tabContentWelcomeSubject"></ng-container>
          </mat-tab>
        </mat-tab-group>
        <ng-template #tabContentWelcomeSubject>
          <div formArrayName="emailTranslations" *ngFor="let item of emailTranslations?.controls; let i = index">
            <mat-form-field
              [formGroupName]="i"
              *ngIf="
                item.get('language').value === selectedLanguage.code &&
                item.get('identifier').value === EMAIL_PAGE_IDENTIFIERS.MAIL_WELCOME_SUBJECT
              "
              fxFill
            >
              <input matInput formControlName="translation" placeholder="E-mail subject" />
            </mat-form-field>
          </div>
        </ng-template>
      </div>
      <div fxLayout="column" class="dashboard-email-page__column">
        <mat-tab-group
          mat-align-tabs="end"
          animationDuration="0ms"
          #languageTabsEditor
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
          (animationDone)="selectFirstTab()"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-template matTabContent>
              <div formArrayName="emailTranslations" *ngFor="let item of emailTranslations?.controls; let i = index">
                <div
                  [formGroupName]="i"
                  *ngIf="
                    item.get('language').value === selectedLanguage?.code &&
                    item.get('identifier').value === EMAIL_PAGE_IDENTIFIERS.MAIL_WELCOME
                  "
                  fxFill
                >
                  <label class="dashboard-email-page__column-label">E-mail body</label>
                  <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div fxLayout="column" class="dashboard-email-page__column">
        <div class="dashboard-email-page__column-title">Participant is rejected</div>
        <mat-tab-group
          mat-align-tabs="end"
          #languageTabs
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
          (animationDone)="selectFirstTab()"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-container *ngTemplateOutlet="tabContentRejectedSubject"></ng-container>
          </mat-tab>
        </mat-tab-group>
        <ng-template #tabContentRejectedSubject>
          <div formArrayName="emailTranslations" *ngFor="let item of emailTranslations?.controls; let i = index">
            <mat-form-field
              [formGroupName]="i"
              *ngIf="
                item.get('language').value === selectedLanguage.code &&
                item.get('identifier').value === EMAIL_PAGE_IDENTIFIERS.MAIL_REJECTED_SUBJECT
              "
              fxFill
            >
              <input matInput formControlName="translation" placeholder="E-mail subject" />
            </mat-form-field>
          </div>
        </ng-template>
      </div>
      <div fxLayout="column" class="dashboard-email-page__column">
        <mat-tab-group
          mat-align-tabs="end"
          animationDuration="0ms"
          #languageTabsEditor
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
          (animationDone)="selectFirstTab()"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-template matTabContent>
              <div formArrayName="emailTranslations" *ngFor="let item of emailTranslations?.controls; let i = index">
                <div
                  [formGroupName]="i"
                  *ngIf="
                    item.get('language').value === selectedLanguage?.code &&
                    item.get('identifier').value === EMAIL_PAGE_IDENTIFIERS.MAIL_REJECTED
                  "
                  fxFill
                >
                  <label class="dashboard-email-page__column-label">E-mail body</label>
                  <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div *ngIf="selectedStudy?.type === StudyType.CC">
      <div fxLayout="column" class="dashboard-email-page__column">
        <div class="dashboard-email-page__column-title">Career Compass outcome</div>
        <mat-tab-group
          mat-align-tabs="end"
          #languageTabs
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
          (animationDone)="selectFirstTab()"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-container *ngTemplateOutlet="tabContentOutcomesSubject"></ng-container>
          </mat-tab>
        </mat-tab-group>
        <ng-template #tabContentOutcomesSubject>
          <div formArrayName="emailTranslations" *ngFor="let item of emailTranslations?.controls; let i = index">
            <mat-form-field
              [formGroupName]="i"
              *ngIf="
                item.get('language').value === selectedLanguage.code &&
                item.get('identifier').value === EMAIL_PAGE_IDENTIFIERS.MAIL_OUTCOMES_SUBJECT
              "
              fxFill
            >
              <input matInput formControlName="translation" placeholder="E-mail subject" />
            </mat-form-field>
          </div>
        </ng-template>
      </div>
      <div fxLayout="column" class="dashboard-email-page__column">
        <mat-tab-group
          mat-align-tabs="end"
          animationDuration="0ms"
          #languageTabsEditor
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
          (animationDone)="selectFirstTab()"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-template matTabContent>
              <div formArrayName="emailTranslations" *ngFor="let item of emailTranslations?.controls; let i = index">
                <div
                  [formGroupName]="i"
                  *ngIf="
                    item.get('language').value === selectedLanguage?.code &&
                    item.get('identifier').value === EMAIL_PAGE_IDENTIFIERS.MAIL_OUTCOMES_INTRO
                  "
                  fxFill
                >
                  <label class="dashboard-email-page__column-label">E-mail intro text</label>
                  <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div fxLayout="column" class="dashboard-email-page__column">
        <mat-tab-group
          mat-align-tabs="end"
          animationDuration="0ms"
          #languageTabsEditor
          (selectedTabChange)="selectTemplateLanguage($event)"
          [disablePagination]="true"
          [selectedIndex]="selectedLanguage?.tabIndex"
          (animationDone)="selectFirstTab()"
        >
          <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
            <ng-template matTabContent>
              <div formArrayName="emailTranslations" *ngFor="let item of emailTranslations?.controls; let i = index">
                <div
                  [formGroupName]="i"
                  *ngIf="
                    item.get('language').value === selectedLanguage?.code &&
                    item.get('identifier').value === EMAIL_PAGE_IDENTIFIERS.MAIL_OUTCOMES_OUTRO
                  "
                  fxFill
                >
                  <label class="dashboard-email-page__column-label">E-mail outro text</label>
                  <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div class="dashboard-email-page-form__actions" fxLayoutAlign="end">
      <button mat-raised-button color="accent" (click)="savePage()">
        {{ 'Save' | uppercase }}
      </button>
    </div>
  </form>
</div>
